// ============================================
// CHALLENGE DEMO
// Presety komunikatów dynamicznego wyzwania (modale + toasty) dla stron demo.
// Kolejność i częstotliwość wyświetlania ustala backend — moduł służy wyłącznie
// do podglądu stanów na stronach *-dynamiczne-*.html oraz w KSS.
//
// Użycie:
//   <div data-challenge-demo="start" hidden></div>          — auto-open po załadowaniu
//   <button data-challenge-demo-trigger="polowa">…</button>  — otwarcie po kliknięciu
//   window.ChallengeDemo.show('sukces');                      — z JS
//   <form data-challenge-demo-form>                           — demo dodawania kodu: każdy submit
//     zwiększa licznik `.challenge-progress` na stronie i pokazuje modal punktowy z blokiem wyzwania
//
// Presety: start, przypomnienie, tydzien, polowa, punkty, sukces, porazka
// ============================================

(function () {
    'use strict';

    var AUTO_OPEN_DELAY = 600; // ms — po animacji hero
    var GAME_PAGE = 'graj-dynamiczne.html';
    var CODES_PAGE = 'own-it-club-dodawaj-kody-dynamiczne.html';
    var REWARDS_PAGE = 'vouchers.html';

    function go(url) {
        return function () {
            window.location.href = url;
        };
    }

    var presets = {
        // Modal startowy — Figma 3897:126082
        start: {
            type: 'modal',
            options: {
                variant: 'challenge',
                image: 'assets/images/own-it-card-big.jpg',
                preheader: 'Dynamiczny bonus:',
                title: 'Ekstra punkty',
                text: '<p>Pierwszy dynamiczny bonus<br> w <strong>Own It Club</strong> wystartował.</p>' +
                    '<p>Dodaj <strong>20 kodów</strong> z paczek<br> w trakcie wyzwania i zgarnij dodatkowe <strong>50 punktów Camel</strong>!</p>',
                confirmLabel: 'Weź udział',
                onConfirm: go(GAME_PAGE)
            }
        },

        // Toast „Chcesz więcej punktów?” — Figma 3897:125823
        przypomnienie: {
            type: 'toast',
            options: {
                variant: 'challenge',
                title: 'Chcesz więcej punktów?',
                text: 'Zarejestruj <strong>20 kodów</strong> w trakcie wyzwania i odbierz dodatkowe <strong>50 punktów Camel</strong>.',
                cta: { label: 'Sprawdź szczegóły', href: GAME_PAGE }
            }
        },

        // Toast „Został tydzień do końca wyzwania!” — Figma 3897:124979
        tydzien: {
            type: 'toast',
            options: {
                variant: 'challenge',
                title: 'Został tydzień do końca wyzwania!',
                text: 'Zarejestruj brakujące kody i zdobądź <strong>50 punktów Camel</strong>.',
                cta: { label: 'Zarejestruj kod', href: CODES_PAGE }
            }
        },

        // Toast „Połowa wyzwania już za nami!” — Figma 3897:126386
        polowa: {
            type: 'toast',
            options: {
                variant: 'challenge',
                title: 'Połowa wyzwania już za nami!',
                text: 'Do końca zostały 2 tygodnie. Dodaj brakujące kody i zgarnij <strong>50 punktów Camel</strong>.',
                cta: { label: 'Dodaj kod z paczki', href: CODES_PAGE }
            }
        },

        // Modal punktowy „Więcej punktów? Załatwione!” — Figma 3897:129211
        punkty: {
            type: 'modal',
            options: {
                variant: 'points',
                image: 'assets/images/own-it-card-big.jpg',
                pointsNumber: '235',
                pointsLabel: 'Punktów',
                text: '<strong>Więcej punktów? Załatwione!</strong><br><br>Oto Twoja nagroda:',
                value: '+ 50 PUNKTÓW',
                textExtra: 'Zobacz, na co możesz je wymienić.',
                confirmLabel: 'Sprawdź katalog nagród',
                onConfirm: go(REWARDS_PAGE)
            }
        },

        // Modal końcowy — sukces — Figma 3897:128323
        sukces: {
            type: 'modal',
            options: {
                variant: 'challenge',
                image: 'assets/images/dynamiczne/challenge-friends.jpg',
                aiBadge: 'Wygenerowane przez AI',
                title: 'Dynamiczny bonus zakończył się!',
                text: '<p><strong>Dziękujemy za udział. 50 punktów Camel trafiło już na Twoje konto.</strong></p>' +
                    '<p>Chcesz więcej? Zaglądaj na stronę, żeby nie przegapić kolejnego wyzwania.</p>',
                confirmLabel: 'Zamknij'
            }
        },

        // Modal końcowy — porażka — Figma 3897:128759
        porazka: {
            type: 'modal',
            options: {
                variant: 'challenge',
                image: 'assets/images/dynamiczne/challenge-friends.jpg',
                aiBadge: 'Wygenerowane przez AI',
                title: 'Dynamiczny bonus zakończył się!',
                text: '<p><strong>Tym razem bez bonusu.</strong></p>' +
                    '<p>Zaglądaj na stronę, żeby nie przegapić kolejnego wyzwania.</p>',
                confirmLabel: 'Zamknij'
            }
        }
    };

    function show(name, basePath) {
        var preset = presets[name];
        if (!preset) return;

        var options = Object.assign({}, preset.options);

        // Ścieżka bazowa obrazów (np. '../' w KSS)
        if (basePath && options.image) {
            options.image = basePath + options.image;
        }

        if (preset.type === 'modal' && window.Modal) {
            window.Modal.show(options);
        } else if (preset.type === 'toast' && window.Toast) {
            window.Toast.show(options);
        }
    }

    /**
     * Komunikat bloku wyzwania w modalu po dodaniu kodu — Figma 3897:149063, 3897:150823
     */
    function challengeForCount(current, total) {
        if (current === 1) {
            return { title: 'Dynamiczny bonus: Ekstra punkty', message: 'Wyzwanie rozpoczęte!' };
        }

        var left = total - current;
        var message = 'Do nagrody zostało: ' + left;
        if (left === 1) message = 'Tylko jeden kod dzieli Cię od nagrody!';
        if (left <= 0) message = 'Cel osiągnięty!';

        return { title: 'Dynamiczny bonus: +1', current: current, total: total, message: message };
    }

    function initDemoForm(form) {
        var progress = document.querySelector('.challenge-progress[data-challenge-total]');
        var points = 220;

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (!progress) return;

            var total = parseInt(progress.getAttribute('data-challenge-total'), 10) || 20;
            var current = Math.min((parseInt(progress.getAttribute('data-challenge-current'), 10) || 0) + 1, total);
            points += 15;

            if (window.ChallengeProgress) {
                window.ChallengeProgress.update(progress, current);
            }

            // Cel osiągnięty — stan success licznika i banera
            if (current >= total) {
                progress.classList.add('challenge-progress--success');
                var status = progress.querySelector('.challenge-progress__status');
                if (status) status.textContent = 'Cel osiągnięty!';
                var banner = progress.closest('.challenge-banner');
                if (banner) banner.classList.add('challenge-banner--success');
            }

            if (window.Modal) {
                window.Modal.show({
                    variant: 'points',
                    image: 'assets/images/own-it-card-big.jpg',
                    pointsNumber: String(points),
                    pointsLabel: 'Punktów',
                    text: 'Kod został wprowadzony poprawnie!',
                    value: '+ 15 PUNKTÓW',
                    challenge: challengeForCount(current, total),
                    confirmLabel: 'Dodaj kolejny kod'
                });
            }

            var field = form.querySelector('input');
            if (field) field.value = '';
        });
    }

    function init() {
        var auto = document.querySelector('[data-challenge-demo]');
        if (auto) {
            setTimeout(function () {
                show(auto.getAttribute('data-challenge-demo'), auto.getAttribute('data-challenge-demo-base'));
            }, AUTO_OPEN_DELAY);
        }

        document.querySelectorAll('[data-challenge-demo-form]').forEach(initDemoForm);

        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-challenge-demo-trigger]');
            if (!trigger) return;
            e.preventDefault();
            show(trigger.getAttribute('data-challenge-demo-trigger'), trigger.getAttribute('data-challenge-demo-base'));
        });
    }

    window.ChallengeDemo = {
        show: show,
        presets: presets
    };

    document.addEventListener('DOMContentLoaded', init);
})();
